import * as React from "react";
import { withFormsy, IFormsyDecorator } from "formsy-react";
import { RadioButton } from "./RadioGroup";

interface Props extends IFormsyDecorator {
  name: string;
  buttons: Item[];
  onChange?(button: Item): void;
}

class MultiselectGroup extends React.PureComponent<Props> {
  render() {
    return (
      <div className="" role="group">
        {this.props.buttons.map((button) => {
          return (
            <RadioButton
              onClick={this.onClick}
              active={this.isSelected(button.value)}
              button={button}
              name={this.props.name}
              key={button.value}
            />
          );
        })}
      </div>
    );
  }

  isSelected = (value: string) => {
    var values = this.props.getValue()?.split(",") ?? [];
    return values.findIndex((selectedValue) => selectedValue == value) != -1;
  };

  onClick = (button: Item) => {
    var values = this.props.getValue()?.split(",") ?? [];
    if (!this.isSelected(button.value)) {
      values.push(button.value);
    } else {
      values = values.filter((value) => value != button.value);
    }
    const value = values.join(",");
    this.props.setValue(value);
    this.props.onChange && this.props.onChange(value);
  };
}

export default withFormsy(MultiselectGroup);
